import React from 'react';

export default function Logo({ size = 'md', showText = true }) {
  const dim = size === 'sm' ? 28 : size === 'lg' ? 72 : 44;
  const fontSize = size === 'sm' ? 15 : size === 'lg' ? 26 : 20;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: dim * 0.25 }}>
      <svg
        width={dim}
        height={dim}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <rect width="64" height="64" rx="10" fill="#4338ca"/>

        {/* Top-left finder pattern */}
        <rect x="6" y="6" width="20" height="20" rx="2.5" fill="white"/>
        <rect x="10" y="10" width="12" height="12" rx="1.5" fill="#4338ca"/>
        <rect x="13" y="13" width="6" height="6" rx="0.5" fill="white"/>

        {/* Top-right finder pattern */}
        <rect x="38" y="6" width="20" height="20" rx="2.5" fill="white"/>
        <rect x="42" y="10" width="12" height="12" rx="1.5" fill="#4338ca"/>
        <rect x="45" y="13" width="6" height="6" rx="0.5" fill="white"/>

        {/* Bottom-left finder pattern */}
        <rect x="6" y="38" width="20" height="20" rx="2.5" fill="white"/>
        <rect x="10" y="42" width="12" height="12" rx="1.5" fill="#4338ca"/>
        <rect x="13" y="45" width="6" height="6" rx="0.5" fill="white"/>

        {/* Data modules bottom-right */}
        <rect x="38" y="38" width="6" height="6" rx="1" fill="white"/>
        <rect x="46" y="38" width="6" height="6" rx="1" fill="white"/>
        <rect x="54" y="38" width="6" height="6" rx="1" fill="white"/>
        <rect x="38" y="46" width="6" height="6" rx="1" fill="white"/>
        <rect x="50" y="46" width="10" height="6" rx="1" fill="white"/>
        <rect x="38" y="54" width="14" height="6" rx="1" fill="white"/>
        <rect x="54" y="54" width="6" height="6" rx="1" fill="white"/>

        {/* Scan line */}
        <rect x="3" y="29" width="58" height="6" rx="3" fill="#f59e0b" opacity="0.95"/>
        <rect x="3" y="29" width="58" height="2" rx="1.5" fill="#fde68a" opacity="0.7"/>
      </svg>

      {showText && (
        <span style={{
          fontWeight: 700,
          fontSize,
          letterSpacing: '-0.5px',
          color: 'inherit',
          lineHeight: 1,
        }}>
          Scanningo<span style={{ color: '#f59e0b' }}>.in</span>
        </span>
      )}
    </div>
  );
}
